import React from "react";

export const About = (props) => {

  /* ================= MAIN / SPECIAL CERTIFICATE ================= */
  const mainCertificate = {
    name: "ISO 9001:2015 – Quality Management System",
    company: "Aerolines Engineering & Construction Pte Ltd",
    issuedBy: "TNV Certification Private Limited",
    scope:
      "Provision of electrical & electronics works, engineering works, industrial automation & civil works",
    certificateNo: "WCZXUTCU20251215SGPQM1Z6",
    validity: "15 December 2025 – 14 December 2028",
    pdf: "/img/pdf/ISO-9001.pdf",
    preview: "/img/pdf/iso9001-preview.jpg",
  };

  /* ================= OTHER CERTIFICATES ================= */
  const certificates = props.data && props.data.certificates
    ? props.data.certificates
    : [
      {
        name: "BCCPE",
        url: "/img/pdf/bccp.pdf",
        preview: "/img/pdf/bccpimage.jpg",
      },
      {
        name: "SCAL",
        url: "/img/pdf/scal.pdf",
        preview: "/img/pdf/scalimage.jpg",
      },
      {
        name: "CIDB G3",
        url: "/img/pdf/cidb.pdf",
        preview: "/img/pdf/cidbimage.jpg",
      },
      {
        name: "Bizsafe Level 3",
        url: "/img/pdf/Bizsafe.pdf",
        preview: "/img/pdf/Bizsafeimage.jpg",
      },
      {
        name: "Public Housing",
        url: "/img/pdf/publichousing.pdf",
        preview: "/img/pdf/publichousingimage.jpg",
      }
    ];

  return (
    <div id="about">
      <div className="container">

        {/* ================= ABOUT SECTION ================= */}
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <img src="img/aboutus-2.jpg" className="img-responsive" alt="Aerolines Engineering & Construction team and facility" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.data ? props.data.paragraph : "loading..."
                }}
              />


              <h3>Why Choose Us?</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                        <li key={`${d}-${i}`}>{d}</li>
                      ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= MAIN CERTIFICATION SECTION ================= */}
        <div
          className="row"
          style={{
            marginTop: "40px",
            padding: "30px 20px",
            border: "1px solid #eee",
            borderRadius: "10px",
            background: "#fafafa",
          }}
        >
          <div className="col-xs-12 col-md-5 text-center">
            <img
              src={mainCertificate.preview}
              alt={mainCertificate.name}
              style={{
                width: "100%",
                maxWidth: "320px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                padding: "10px",
                background: "#fff",
              }}
            />
          </div>

          <div className="col-xs-12 col-md-7">
            <h3 style={{ marginTop: "0" }}>
              {mainCertificate.name}
            </h3>

            <p>
              <strong>Certified Organization:</strong><br />
              {mainCertificate.company}
            </p>

            <p>
              <strong>Scope of Certification:</strong><br />
              {mainCertificate.scope}
            </p>

            <p>
              <strong>Issued By:</strong> {mainCertificate.issuedBy}
            </p>

            <p>
              <strong>Certificate No:</strong> {mainCertificate.certificateNo}
            </p>

            <p>
              <strong>Validity:</strong> {mainCertificate.validity}
            </p>

            <a
              href={mainCertificate.pdf}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ marginTop: "10px" }}
            >
              View Certificate
            </a>
          </div>
        </div>

        {/* ================= OTHER CERTIFICATES ================= */}
        <div className="row" style={{ marginTop: "40px" }}>
          <div className="col-12">
            <h3 className="text-center">Our Certifications</h3>

            <div
              className="certificates-container"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              {certificates.map((cert, index) => (
                <a
                  key={index}
                  href={cert.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    flex: "0 0 auto",
                  }}
                >
                  <div
                    className="certificate-card"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      overflow: "hidden",
                      transition: "0.3s",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "10px",
                      maxWidth: "200px",
                      background: "#fff",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <img
                      src={cert.preview}
                      alt={cert.name}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                    <p
                      style={{
                        marginTop: "10px",
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      {cert.name}
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
